import { render, staticRenderFns } from "./NumerosGuru.vue?vue&type=template&id=0274d2b9"
import script from "./NumerosGuru.vue?vue&type=script&lang=js"
export * from "./NumerosGuru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports